import { Reducer } from "react"
import { handleActions } from "redux-actions"
import { 
    ACTION_GETREPORTLISTENTRYINS_SUCCESS,
    ACTION_GETREPORTLISTENTRYMERCHANT_SUCCESS,
    ACTION_GETREPORTDETAILENTRYINS_SUCCESS,
    ACTION_GETREPORTDETAILENTRYMERCHANT_SUCCESS,
    ACTION_GETREPORTPRESSURE_SUCCESS,
    ACTION_GETREPORTINSOLEMODELSTL_SUCCESS,
    ACTION_SAVEINSOLEMODEL_SUCCESS,
    ACTION_UPDATEREPORTINSOLEMODEL_SUCCESS,
    ACTION_OPERATEREPORTREMARK_SUCCESS,
    ACTION_GETREPORTSTATUS_SUCCESS,
    ACTION_GETFOOTARCHVALUERANGE_SUCCESS,
 } from "../../actions/scanner/report"

export interface reportState {
    reportList: any
    reportDetail: any
    userInfo: any
    reportPressure: any
    insoleModel: any,
    insoleModelState: any, // 初始状态使用
    shoeSizeList: any,
    updateInsoleStl: boolean,
    footArchValueRange: any[],
}

const defaultState: reportState = {
    reportList: {},
    reportDetail: {},
    userInfo: {},
    reportPressure: {},
    insoleModel: {
        left: {},
        right: {},
    },
    insoleModelState: {
        left: {},
        right: {},
    },
    shoeSizeList: {
        left: [],
        right: [],
    },
    updateInsoleStl: false,
    footArchValueRange: [],
}

function handleActionGetReportListEntryInsSuccess(state: reportState, action): reportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        reportList: action.payload.data
    }
}

function handleActionGetReportStatusSuccess(state: reportState, action): reportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        reportList: action.payload.data
    }
}

function handleActionGetReportListEntryMerchantSuccess(state: reportState, action): reportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        reportList: action.payload.data
    }
}

function handleActionGetReportDetailEntryInsSuccess(state: reportState, action): reportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        reportDetail: action.payload.data,
        shoeSizeList: action.payload.shoeSizeList,
        insoleModelState: action.payload.insoleModelState,
    }
}

function handleActionGetReportDetailEntryMerchantSuccess(state: reportState, action): reportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        reportDetail: action.payload.data,
        shoeSizeList: action.payload.shoeSizeList,
    }
}

function handleActionGetReportPressureSuccess(state: reportState, action): reportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        reportDetail: action.payload.data,
        userInfo: action.payload.userInfo,
        reportPressure: action.payload.balanceReport,
    }
}

function handleActionGetReportInsoleModelStlSuccess(state: reportState, action): reportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        insoleModel: action.payload.data,
        updateInsoleStl: true,
    }
}

function handleActionSaveInsoleModelSuccess(state: reportState, action): reportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        insoleModel: action.payload.data,
        updateInsoleStl: action.payload.updateInsoleStl,
    }
}

function handleActionUpdateReportInsoleModelSuccess(state: reportState, action): reportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        insoleModel: action.payload.data,
        insoleModelState: action.payload.data,
    }
}

function handleActionOperateReportRemarkSuccess(state: reportState, action): reportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
    }
}

function handleActionFootArchValueRangeSuccess(state: reportState, action): reportState {
    console.log(`ACTION: ${action.type}`)
    return {
        ...state,
        footArchValueRange: action.payload.data
    }
}

export const reportReducer: Reducer<reportState, any> = handleActions(
    {
        [ACTION_GETREPORTLISTENTRYINS_SUCCESS]: handleActionGetReportListEntryInsSuccess,
        [ACTION_GETREPORTLISTENTRYMERCHANT_SUCCESS]: handleActionGetReportListEntryMerchantSuccess,
        [ACTION_GETREPORTDETAILENTRYINS_SUCCESS]: handleActionGetReportDetailEntryInsSuccess,
        [ACTION_GETREPORTDETAILENTRYMERCHANT_SUCCESS]: handleActionGetReportDetailEntryMerchantSuccess,
        [ACTION_GETREPORTPRESSURE_SUCCESS]: handleActionGetReportPressureSuccess,
        [ACTION_GETREPORTINSOLEMODELSTL_SUCCESS]: handleActionGetReportInsoleModelStlSuccess,
        [ACTION_SAVEINSOLEMODEL_SUCCESS]: handleActionSaveInsoleModelSuccess,
        [ACTION_UPDATEREPORTINSOLEMODEL_SUCCESS]: handleActionUpdateReportInsoleModelSuccess,
        [ACTION_OPERATEREPORTREMARK_SUCCESS]: handleActionOperateReportRemarkSuccess,
        [ACTION_GETREPORTSTATUS_SUCCESS]: handleActionGetReportStatusSuccess,
        [ACTION_GETFOOTARCHVALUERANGE_SUCCESS]: handleActionFootArchValueRangeSuccess,
    },
    defaultState
)